import { defineStore } from 'pinia';
import type { Company, Brand } from '@Shared';
import { getCompanyInfoFromSessionApi } from '@Api/company.api';

export const useCompanyStore = defineStore('company', {
    state: () => ({
        company: null as Company | null,
        brand: null as Brand | null,
        companySlug: null as string | null,
    }),
    actions: {
        setCompany(newCompany: Company) {
            this.company = newCompany;
        },
        setBrand(newBrand: Brand | null) {
            this.brand = newBrand;
        },
        async loadCompany() {
            const companyInfo = await getCompanyInfoFromSessionApi();
            if (companyInfo) {
                this.company = companyInfo as unknown as Company;
            }
        },
    },
});
